module.exports = __webpack_public_path__ + "img/notyphoon.20e1fdad.png";